import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
  constructGroupLinkedUsersText,
  groupRolePriviledge
} from "../../../utils/constants";
import { toolkitCategories } from "../../../utils/categories";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  ModalHeader,
} from "reactstrap";
import noResources from "../../../assets/onboarding/toolkit.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import { isMobile } from "../../../utils/deviceInfo";
import ToolDetails from "../../toolkit/ToolDetails/Details/ToolDetails";

class GroupResources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      resources: [],
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isLoaded: false,
      mobileDetailsPopupOpen: false,
      popupParams: {},
      popupPath: "",
    };
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    let that = this;
    let payload = {
      groupId: id,
      modelName: "OfficeToolkit",
      noLoader: true,
      // modelType:'Conferences & Events'
    };
    this.props.highlightMenu("R");
    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      that.setState({
        resources: data.data.items,
        isLoaded: true,
      });
    });
  }

  toggleMobileDetailsPopup = () => {
    if (this.state.mobileDetailsPopupOpen) {
      this.setState({ popupParams: {}, popupPath: "" });
    }
    this.setState({
      mobileDetailsPopupOpen: !this.state.mobileDetailsPopupOpen,
    });
  };

  removeGroup = item => {
    let { resources } = this.state;
    if (this.props.group) {
      let payload = {
        modelId: item._id,
        modelName: "OfficeToolkit",
        // itemType:item.itemType,
        groupId: this.props.group._id,
      };
      let that = this;
      axios.post(url.removeGrpItem, payload).then(({ data }) => {
        console.log(resources);
        let res = resources.filter(ev => ev._id != item._id);
        that.setState({
          // isRemoved:true
          resources: res,
          removedItem: item,
          isSuccess: true,
          // selected:null,
          // linkedGrp:result,  modDoc:doc,
          // groupList:[ doc ,...this.state.groupList],
          // displayItems:result
          // groupList:
          // isSuccessMsg: 0,
          // selected: {...selected, ...data.data}
        });
      });
    }
  };

  viewTool = tool => {
    let { category } = tool;
    let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
    let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
    if (isMobile) {
      this.setState({
        mobileDetailsPopupOpen: true,
        popupParams: {
          id: tool._id,
          category: tool_cat.link,
          popupPath: tool_link,
        },
      });
    } else {
      let { category } = tool;
      let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
      let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
      this.props.history.push(tool_link);
    }
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };

  renderResources = tasks => {
    const { orgAdmin } = this.props.user.profile;
    let { resources, isSuccess, removedItem } = this.state;
    return (
      <span>
        {isSuccess ? (
          <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
            <strong>{removedItem.name}</strong> was removed.
          </Alert>
        ) : null}

        <div className="singleTaskToolkitTableContainerBox">
          <Table responsive hover className="taskToolkitTable">
            <thead>
              <tr>
                <th>Name</th>
                <th>Category</th>
                {/* <th>Created By</th> */}
                <th>Date Linked</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {/* resources.map(({modelId:item},idx) => */}
              {resources.map((item, idx) => {
                return (
                  <React.Fragment key={idx + item._id}>
                    <tr className="linkedToolTable" key={item._id}>
                      <td>
                        {item.name}{" "}
                        <span
                          className="linkedToolView"
                          onClick={() => this.viewTool(item)}
                        >
                          (view)
                        </span>
                      </td>

                      <td>{item.category}</td>

                      <td className="grp_single_page_event_date_css">
                        {moment(item.createdAt).format("MMM Do, YYYY")}
                        <br/>
                        {constructGroupLinkedUsersText(item)}
                      </td>

                      <td className="grp_single_page_remove_css">
                      {groupRolePriviledge({
                      role: this.props.currentRole,
                      action: 0,
                      group: this.props.group,
                      
                      role_priv: [0, 1, 2],
                      comparison: null,
                      isAdmin: this.props.currentRole == 0,
                    }) || item.userId == this.props.user.profile._id || (item.linkedByUser &&item.linkedByUser._id == this.props.user.profile._id) ? (
                 
                         <span
                          onClick={() => this.removeGroup(item)}
                          className="chart-item-menu flaticon-trash"
                        />
                  
                    ) : null}
                      
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      </span>
    );
  };

  render() {
    let { resources, isLoaded, mobileDetailsPopupOpen } = this.state;

    return (
      <span className="grp_single_page_stories_container resources_component_container">
        {mobileDetailsPopupOpen && (
          <Modal
            isOpen={mobileDetailsPopupOpen}
            toggle={this.toggleMobileDetailsPopup}
          >
            <ModalHeader toggle={this.toggleMobileDetailsPopup}>
              View Resource
            </ModalHeader>
            <ModalBody>
              <ToolDetails
                match={{ params: this.state.popupParams }}
                isPopup={true}
                history={{
                  location: { pathname: this.state.popupPath, search: "" },
                  ...this.props.history,
                }}
              />
            </ModalBody>
          </Modal>
        )}

        {isLoaded != true ? (
          <div className="grp_single_page_details_analytics_container">
            <span className="grp_single_page_no_analytics">
              <img src={loadingItems} className="grpNoLinkedCharts" />{" "}
              Loading...
            </span>
          </div>
        ) : isLoaded ? (
          resources && resources.length > 0 ? (
            <div className="grp_single_page_resources_component_container">
              {this.renderResources()}
            </div>
          ) : (
            <div className="grp_single_page_details_analytics_container">
              <span className="grp_single_page_no_analytics cursor-pointer">
                <img src={noResources} className="grpNoLinkedCharts" /> No items
                have been linked to Resources.
                <div
                  className="grp_page_events_subtitle"
                  onClick={() => this.props.history.push(`/home/toolkit/all`)}
                >
                  Click here to link Resources.
                </div>
              </span>
            </div>
          )
        ) : null}
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupResources, axios)));
